import type { LeadAnalytics, LeadAnalyticsData } from '../Models/LeadAnalytics';

type AnalyticsWindow = Window & {
  leadAnalytics?: LeadAnalytics;
  Cookiebot?: { consent?: { statistics?: boolean; marketing?: boolean } };
};

function collectConsentOnly(): LeadAnalyticsData {
  const consent = (window as AnalyticsWindow).Cookiebot?.consent;
  return {
    firstPage: '',
    campaign: '',
    tracking: {
      clientId: '', sessionId: '', gclid: '', gbraid: '', wbraid: '', fbc: '', fbp: '',
      consentAnalytics: consent?.statistics === true,
      consentMarketing: consent?.marketing === true
    }
  };
}

// No runtime dependency on the optional analytics entry. Never queue events before consent.
export function trackLead(event: string, properties: Record<string, string> = {}): void {
  try {
    (window as AnalyticsWindow).leadAnalytics?.track(event, properties);
  } catch { /* Optional analytics must not interrupt site functionality. */ }
}

export async function collectLeadAnalytics(): Promise<LeadAnalyticsData> {
  const analytics = (window as AnalyticsWindow).leadAnalytics;
  if (!analytics) return collectConsentOnly();

  let timer: number | undefined;
  try {
    // A blocked, failed, or unresponsive analytics entry must not prevent submission.
    return await Promise.race([
      analytics.collect(),
      new Promise<LeadAnalyticsData>(resolve => {
        timer = window.setTimeout(() => resolve(collectConsentOnly()), 1500);
      })
    ]);
  } catch {
    return collectConsentOnly();
  } finally {
    window.clearTimeout(timer);
  }
}
